import React, { useCallback, useEffect } from 'react';
import { isEmpty } from 'lodash/lang';

import TaskApi from '../../../../../api/calendar/TaskApi';
import { NavigationPanel } from '../../../../../common/fullScreenLayout/FullScreenLayout';
import openKeepIsHidden from '../../../../root/Container/Layout/Tasks/openKeepIsHidden';
import { useCurrentRoute } from '../../../../root/router';

import { ReviewContent } from './ReviewContent/ReviewContent';
import ReviewControl from './ReviewControl/ReviewControl';
import ReviewInfoHeader from './ReviewInfoHeader/ReviewInfoHeader';
import { ReviewSideBar } from './ReviewSideBar/ReviewSideBar';
import { ReviewProvider } from './ReviewContext';

import './ReviewPage.scss';

export function ReviewPage() {
  const currentRoute = useCurrentRoute();

  const getRelatedTasksForEncounter = useCallback(
    function() {
      const { ssuPatientId, patientEncounterId } = currentRoute.params;
      TaskApi.getTasksByPatientIdAndEncounter(ssuPatientId, patientEncounterId).then(({ data }) => {
        if (!isEmpty(data)) {
          openKeepIsHidden(data[0].taskId, data[0].ssuId);
        }
      });
    },
    [currentRoute.params]
  );

  useEffect(() => {
    getRelatedTasksForEncounter();
  }, [getRelatedTasksForEncounter]);

  return (
    <ReviewProvider>
      <ReviewInfoHeader />
      <div className="eds-review-page">
        <div className="eds-review-page-container">
          <div className="eds-review-page-body">
            <NavigationPanel>
              <ReviewSideBar />
            </NavigationPanel>
            <div className="eds-main-content">
              <ReviewControl />
              <ReviewContent />
            </div>
          </div>
        </div>
      </div>
    </ReviewProvider>
  );
}
